<div class="row" *ngIf='readOnly'>
  <div class="col-md-12 col-sm-12 table-responsive no-border">
    <form [formGroup]="deviceForm" novalidate>

      <ng-template #chinaTemplate>
        <table class="table table-inner table-condensed table-striped table-50">
          <tbody>
            <tr>
              <th role="columnheader" aria-label="MRI Safety Status">
                MRI Safety Status
              </th>
            </tr>
            <tr>
              <td role="gridcell" aria-label="Cell of MRI Safety Status">
                <label controlName="mriSafetyStatus"> </label>
              </td>
            </tr>
          </tbody>
        </table>
      </ng-template>

      <table class="table table-inner table-condensed table-striped table-50"
        *ngIf="dataScope.toLowerCase() === dataScopeEnum.SKOREA.toLowerCase(); else chinaTemplate">
        <tbody>
          <tr>
            <th role="columnheader" aria-label="Containing Latex?" class="col-sm-6">
              Containing Latex?
            </th>
            <th role="columnheader" aria-label="Containing Phthalates?" class="col-sm-6">
              Containing Phthalates?
            </th>
          </tr>
          <tr>
            <td role="gridcell" aria-label="Cell of Containing Latex?">
              <label controlName="containingLatex"> </label>
            </td>
            <td role="gridcell" aria-label="Cell of Containing Phthalates?">
              <label controlName="containingPhthalates"> </label>
            </td>
          </tr>
        </tbody>
      </table>

      <table class="table table-inner table-condensed table-striped"
        *ngIf="dataScope.toLowerCase() === dataScopeEnum.SKOREA.toLowerCase()">
        <tbody>
          <tr>
            <th role="columnheader" aria-label="MRI Safety Status" class="col-sm-3">
              MRI Safety Status
            </th>
            <th role="columnheader" aria-label="Critical Warnings and Contraindications" class="col-sm-9">
              Critical Warnings and Contraindications
            </th>
          </tr>
          <tr>
            <td role="gridcell" aria-label="Cell of MRI Safety Status">
              <label controlName="mriSafetyStatus"> </label>
            </td>
            <td role="gridcell" aria-label="Cell of Critical Warnings and Contraindications" class="breakAll">
              <label controlName="criticalWarningAndContraindication"> </label>
            </td>
          </tr>
        </tbody>
      </table>
    </form>
  </div>
</div>
